<template>
  <div>
    <div class="w3-container">
      <div class="headerGridCMS w3-hide-print">
        <div>
          <header>
            <h2><template v-if="$route.params.slug">Edit</template><template v-else>New</template> Team Member</h2>
          </header>
        </div>
        <div>
          <button class='w3-button w3-right w3-small vmiddle w3-red' style="margin-left:8px;" @click="exitMember()">Exit</button>
          <button class='w3-button w3-right w3-small vmiddle' :class="saving || saved ? 'w3-dark-teal' : 'w3-teal'" :disabled="saving || saved" @click="saveContent()"><span v-if="!saved">Save</span><span v-if="saved">Saved</span></button>
        </div>
      </div>
      <div class="teamDetailGrid">
        <div>
          <div class="inputCard">
            <header class="w3-left-align">Main</header>
            <div class="content">
              <div class="cardRow w3-padding-8">
                <label>Name</label>
                <input v-model="member.name" class="w3-input w3-border" />
              </div>
              <div class="cardRow w3-padding-8">
                <label>Title</label>
                <input v-model="member.title" class="w3-input w3-border" />
              </div>
              <div class="cardRow w3-padding-8">
                <label>Phone</label>
                <input v-model="member.phone" class="w3-input w3-border" />
              </div>
              <div class="cardRow w3-padding-8">
                <label>Phone Link</label>
                <input v-model="member.phoneLink" placeholder="tel:1234567890" class="w3-input w3-border" />
              </div>
              <div class="cardRow w3-padding-8">
                <label>Phone 2</label>
                <input v-model="member.phone2" class="w3-input w3-border" />
              </div>
              <div class="cardRow w3-padding-8">
                <label>Phone 2 Link</label>
                <input v-model="member.phone2Link" placeholder="tel:1234567890" class="w3-input w3-border" />
              </div>
              <div class="cardRow w3-padding-8">
                <label>Fax</label>
                <input v-model="member.fax" class="w3-input w3-border" />
              </div>
              <div class="cardRow w3-padding-8">
                <label>Email</label>
                <input v-model="member.email" class="w3-input w3-border" />
              </div>
              <div class="cardRow w3-padding-8">
                <label>Facebook</label>
                <input v-model="member.facebook" class="w3-input w3-border" />
              </div>
              <div class="cardRow w3-padding-8">
                <label>Twitter</label>
                <input v-model="member.twitter" class="w3-input w3-border" />
              </div>
              <div class="cardRow w3-padding-8">
                <label>Instagram</label>
                <input v-model="member.instagram" class="w3-input w3-border" />
              </div>
              <div class="cardRow w3-padding-8">
                <label>LinkedIn</label>
                <input v-model="member.linkedin" class="w3-input w3-border" />
              </div>
              <div class="inputRow w3-padding-8">
                <label class="w3-padding-bottom">Content</label>
                <tinymce-editor api-key="t5p4kok2r7znye5exinvmcmpazco8x8rd3hoapujd41dps8c" :init="{plugins: 'code, autoresize, link, lists', autoresize_bottom_margin: 0, statusbar: false, max_height: 300, menubar: false, toolbar: 'undo redo | bold italic underline | formatselect | alignleft aligncenter alignright |  numlist bullist | link | removeformat | code', forced_root_block : '', relative_urls: false, entity_encoding : 'raw'}" v-model="member.content"></tinymce-editor>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="inputCard">
            <header>Image</header>
            <div class="content">
              <div class="cardRow w3-padding-8" style="border-bottom:0;">
                <label style="margin-top:6px;">Image (550x412)</label>
                <div class="w3-right-align">
                  <label for="memberFile" class="w3-button w3-green w3-small" style="margin-top:0;">Upload Image</label>
                  <input id="memberFile" type="file" @change="uploadImage($event.target.files)" ref="fileUpload" accept=".png,.jpg" class="inputFile" />
                </div>
              </div>
              <div class="w3-center w3-border-bottom w3-padding-bottom">
                <img v-if="member.image && member.image.src !== ''" :src="member.image.src" style="width:100%; max-width:300px;" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
var slug = require('slug')
var dataStore = require('../../dataStore').default

export default {
  name: 'cmsteamdetail',
  data() {
    return {
      state: dataStore.state,
      member: null,
      saving: false,
      saved: false
    }
  },
  components: {
    'tinymce-editor': Editor
  },
  created() {
    this.initMember()
    if (this.$route.params.url) {
      for (let savedMember of this.state.siteData.content.team.items) {
        if (this.$route.params.url === savedMember.url) {
          this.member = savedMember
          break
        }
      }
    }
  },
  methods: {
    initMember() {
      this.member = {
        title: '',
        text: '',
        url: '',
        facebook: '',
        twitter: '',
        linkedin: '',
        image: {
          src: ''
        },
        content: ''
      }
    },
    uploadImage(files) {
      dataStore.uploadImage(files).then((path) => {
        this.member.image = {
          src: path
        }
        console.log(path)
      })
    },
    saveContent() {
      let loopIndex = 0
      let found = false
      this.member.url = slug(this.member.name)
      for (let member of this.state.siteData.content.team.items) {
        if (member.url === this.member.url) {
          if (!confirm('Member with this Name already exists, overwrite?')) {
            return
          } else {
            found = true
            break
          }
        }
        loopIndex++
      }
      if (found) {
        this.state.siteData.content.team.items[loopIndex] = this.member
      } else {
        this.state.siteData.content.team.items.push(this.member)
      }
      this.saving = true
      dataStore.saveSiteData().then((res) => {
        this.saving = false
        if (res === 'success') {
          this.$router.replace('/cms/team')
        }
      })
    },
    exitMember() {
      this.initMember()
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
  .teamContentGrid {display:grid; grid-template-columns: 1fr 250px 130px; grid-gap: 8px;}
  .buttons {text-align: right;}
  header.w3-left-align {padding-left:12px;}

  .teamDetailGrid {display:grid; grid-template-columns: 3fr 1fr; grid-gap: 8px;}
@media screen and (max-width:993px) {
  .headerGridCMS {grid-template-columns: 1fr 1fr;}
  .cardRow {grid-template-columns: 1fr;}
}
</style>



// WEBPACK FOOTER //
// src/components/cms/cmsTeamDetail.vue